import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-c317f98e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = ["title"]
const _hoisted_3 = { class: "info cm-ui-mt10" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = ["title"]
const _hoisted_6 = { class: "info cm-ui-mt10" }
const _hoisted_7 = { class: "sub-row" }
const _hoisted_8 = { class: "sub-row" }
const _hoisted_9 = { class: "sub-row" }
const _hoisted_10 = { class: "sub-row" }
const _hoisted_11 = { class: "sub-row" }
const _hoisted_12 = { class: "sub-row" }
const _hoisted_13 = {
  key: 0,
  class: "sub-row"
}
const _hoisted_14 = { class: "sub-row" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = ["title"]
const _hoisted_17 = { class: "info cm-ui-mt10" }
const _hoisted_18 = { class: "sub-row" }
const _hoisted_19 = { class: "cm-ui-mt5" }
const _hoisted_20 = { style: {"position":"relative","top":"-1px"} }
const _hoisted_21 = {
  key: 0,
  class: "row"
}
const _hoisted_22 = { class: "rb-btn" }

import { reactive, ref, watch, computed, PropType } from 'vue'
import { useI18n } from 'vue-i18n'
import ContentAdaptLayout from '../../../../_components/content-adapt-layout/content-adapt-layout.vue'
import {
  GroupPolicySettingsService,
  GroupPolicyTypes,
  RealTimeProtectionSettings
} from '../../group-policy-settings.service'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { OperateType } from '@/views/dashboard/_components/group-policy-settings/group-policy-drawer.service'
import { IS_JP_ONLY_BUILD } from '@/common/const/build-locale'


export default /*#__PURE__*/_defineComponent({
  __name: 'real-time-protection',
  props: {
  operateType: {
    type: String as PropType<'edit' | 'add' | 'read'>,
    default: 'edit'
  },
  policyId: {
    type: String,
    default: undefined
  },
  name: {
    type: String,
    default: ''
  },
  activeName: {
    type: String,
    default: ''
  }
},
  emits: ['cancel', 'save'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n()

const DEFAULT_PARAMS: RealTimeProtectionSettings = {
  main_switch: 0,
  program_switch: 0,
  load_driver_switch: 0,
  reg_switch: 0,
  inject_switch: 0,
  key_area_switch: 0,
  desktop_switch: 0,
  udisk_switch: 0,
  memory_defend_switch: 0,
}

const props = __props

const emits = __emit

const injector = useReflectiveInjector()
const groupPolicySettingsService = injector.get(GroupPolicySettingsService)
const loading = ref<boolean>(true)
const strategy = reactive<RealTimeProtectionSettings>({
  ...DEFAULT_PARAMS
})
const data = reactive({
  hasEdit: false
})

const mainSwitchValue = computed({
  get: () => strategy.main_switch === 1,
  set: (val: boolean) => {
    strategy.main_switch = val ? 1 : 0
  }
})

function getSettings () {
  groupPolicySettingsService.getSettings({
    id: props.policyId,
    type: GroupPolicyTypes.RealTimeProtection
  }).then(response => {
    Object.assign(strategy, {
      ...DEFAULT_PARAMS,
    }, response.strategy)
  }).finally(() => {
    loading.value = false
  })
}

function saveSettings () {
  groupPolicySettingsService.saveSettings({
    id: props.policyId,
    type: GroupPolicyTypes.RealTimeProtection,
    strategy: JSON.stringify(strategy)
  }).then(() => {
    groupPolicySettingsService.updateEditTab(false)
    emits('save', 'real-time-protection')
  })
}

function cancel () {
  emits('cancel')
}

function handlerSave () {
  saveSettings()
}

function setChangeStatus () {
  groupPolicySettingsService.updateEditTab(true)
}

groupPolicySettingsService.hasEditTab.subscribe((hasEdit: boolean) => {
  data.hasEdit = hasEdit
})

groupPolicySettingsService.saveTab.subscribe((name: string) => {
  if (name === 'real-time-protection') {
    saveSettings()
  }
})

watch(() => props.activeName, (newV) => {
  if (newV === 'real-time-protection') {
    getSettings()
  }
})

getSettings()

return (_ctx: any,_cache: any) => {
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_CmSvgIcon = _resolveComponent("CmSvgIcon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(ContentAdaptLayout, { class: "container" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("label", {
          class: "row-label",
          title: _unref(t)('groupPolicySettings.rtEnableRealtime')
        }, [
          _createElementVNode("strong", null, _toDisplayString(_unref(t)('groupPolicySettings.rtEnableRealtime')), 1)
        ], 8, _hoisted_2),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_switch, {
            modelValue: mainSwitchValue.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((mainSwitchValue).value = $event)),
            disabled: __props.operateType === _unref(OperateType).read,
            onChange: setChangeStatus
          }, null, 8, ["modelValue", "disabled"])
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("label", {
          class: "row-label",
          title: _unref(t)('groupPolicySettings.rtFuncSettings')
        }, [
          _createElementVNode("strong", null, _toDisplayString(_unref(t)('groupPolicySettings.rtFuncSettings')), 1)
        ], 8, _hoisted_5),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_el_col, { onChange: setChangeStatus }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_el_checkbox, {
                  class: "type-radio",
                  modelValue: strategy.program_switch,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((strategy.program_switch) = $event)),
                  modelModifiers: { number: true },
                  "true-label": 1,
                  "false-label": 0,
                  disabled: !mainSwitchValue.value || __props.operateType === _unref(OperateType).read
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.rtProgGuard')), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_el_checkbox, {
                  class: "type-radio",
                  modelValue: strategy.load_driver_switch,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((strategy.load_driver_switch) = $event)),
                  modelModifiers: { number: true },
                  "true-label": 1,
                  "false-label": 0,
                  disabled: !mainSwitchValue.value || __props.operateType === _unref(OperateType).read
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.rtDriverGuard')), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_el_checkbox, {
                  class: "type-radio",
                  modelValue: strategy.reg_switch,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((strategy.reg_switch) = $event)),
                  modelModifiers: { number: true },
                  "true-label": 1,
                  "false-label": 0,
                  disabled: !mainSwitchValue.value || __props.operateType === _unref(OperateType).read
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.rtRegistryGuard')), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_el_checkbox, {
                  class: "type-radio",
                  modelValue: strategy.inject_switch,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((strategy.inject_switch) = $event)),
                  modelModifiers: { number: true },
                  "true-label": 1,
                  "false-label": 0,
                  disabled: !mainSwitchValue.value || __props.operateType === _unref(OperateType).read
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.rtInjectGuard')), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_el_checkbox, {
                  class: "type-radio",
                  modelValue: strategy.key_area_switch,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((strategy.key_area_switch) = $event)),
                  modelModifiers: { number: true },
                  "true-label": 1,
                  "false-label": 0,
                  disabled: !mainSwitchValue.value || __props.operateType === _unref(OperateType).read
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.rtCriticalGuard')), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_el_checkbox, {
                  class: "type-radio",
                  modelValue: strategy.desktop_switch,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((strategy.desktop_switch) = $event)),
                  modelModifiers: { number: true },
                  "true-label": 1,
                  "false-label": 0,
                  disabled: !mainSwitchValue.value || __props.operateType === _unref(OperateType).read
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.rtDesktopGuard')), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              (!_unref(IS_JP_ONLY_BUILD))
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createVNode(_component_el_checkbox, {
                      class: "type-radio",
                      modelValue: strategy.udisk_switch,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((strategy.udisk_switch) = $event)),
                      modelModifiers: { number: true },
                      "true-label": 1,
                      "false-label": 0,
                      disabled: !mainSwitchValue.value || __props.operateType === _unref(OperateType).read
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.rtUsbGuard')), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "disabled"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_el_checkbox, {
                  class: "type-radio",
                  modelValue: strategy.memory_defend_switch,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((strategy.memory_defend_switch) = $event)),
                  modelModifiers: { number: true },
                  "true-label": 1,
                  "false-label": 0,
                  disabled: !mainSwitchValue.value || __props.operateType === _unref(OperateType).read
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.rtMemoryGuard')), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("label", {
          class: "row-label",
          title: _unref(t)('groupPolicySettings.rtExecConfig')
        }, [
          _createElementVNode("strong", null, _toDisplayString(_unref(t)('groupPolicySettings.rtExecConfig')), 1)
        ], 8, _hoisted_16),
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_el_col, { onChange: setChangeStatus }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_el_checkbox, {
                  class: "type-radio",
                  modelValue: strategy.light_weight_switch,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((strategy.light_weight_switch) = $event)),
                  modelModifiers: { number: true },
                  "true-label": 1,
                  "false-label": 0,
                  disabled: !mainSwitchValue.value || __props.operateType === _unref(OperateType).read
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.rtLightMode')), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"]),
                _createVNode(_component_el_tooltip, {
                  placement: "top",
                  effect: "light"
                }, {
                  content: _withCtx(() => [
                    _createElementVNode("div", null, _toDisplayString(_unref(t)('groupPolicySettings.rtLightModeLine1')), 1),
                    _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(t)('groupPolicySettings.rtLightModeLine2Realtime')), 1)
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("i", _hoisted_20, [
                      _createVNode(_component_CmSvgIcon, {
                        name: "assets/icons/info-gray",
                        size: 18,
                        monochrome: "",
                        "aria-hidden": false,
                        "aria-label": "info"
                      })
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ])
      ]),
      (__props.operateType !== _unref(OperateType).read)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createVNode(_component_el_button, {
                class: "cm-ui-ml10",
                size: "small",
                type: "primary",
                onClick: handlerSave,
                disabled: !data.hasEdit && __props.operateType !== _unref(OperateType).add && 0
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('common.save')), 1)
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_component_el_button, {
                size: "small",
                onClick: cancel
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('common.cancel')), 1)
                ]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  })), [
    [_directive_loading, loading.value]
  ])
}
}

})